module.exports = {
  bronzemonthly: {
    label: 'Billed Monthly',
    stripeId: 'bronze',
    subtext: '',
    basePrice: 2499,
    suffix: '/ mo',
    period: 'month',
  },
  bronzeyearly: {
    label: 'Billed Annually',
    stripeId: 'bronze-yearly',
    subtext: 'Save 33%',
    basePrice: 19999,
    suffix: '/ yr',
    period: 'year',
    default: true,
  },
};



// WEBPACK FOOTER //
// ./src/common/plans.js